var _rect, _rect2, _rect3, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorGeneric(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 83,
    viewBox: "0 0 135 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 8,
    y: 78,
    width: 127,
    height: 5,
    rx: 2.5,
    fill: "#e3e9f0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7955,
    y: 17.7955,
    width: 105.437,
    height: 63.6364,
    rx: 1.75,
    fill: "#f5f8fa",
    stroke: "#b3becd",
    strokeWidth: 1.59091,
    strokeDasharray: "3.18 1.59"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7955,
    y: 17.7955,
    width: 71.5909,
    height: 63.6364,
    rx: 1.75,
    fill: "#fff",
    stroke: "#b3becd",
    strokeWidth: 1.59091,
    strokeDasharray: "3.18 1.59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8608 53.6067 58.8604 44.6072",
    stroke: "#b3becd",
    strokeWidth: 1.59091,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8604 53.6067 49.8608 44.6072",
    stroke: "#b3becd",
    strokeWidth: 1.59091,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorGeneric);
export default __webpack_public_path__ + "static/media/error-generic.060e9e61.svg";
export { ForwardRef as ReactComponent };